module.exports = "<div class=\"online-order\">\n  <div ng-view></div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.html
// module id = 159
// module chunks = 0